<i class="al-icon" [class]="iconClass + ' al-ico-type-' + (type ? (type.toString()).replace('_', '-') : 'training')"></i>
<span class="ms-2 ellipsis" [class]="type" *ngIf="showLabel">
  {{type?.length < 4 ? type?.toUpperCase() : (type | noUnderscore | titlecase)}}
</span>

